import { TrackJS } from 'trackjs';

export const log = {
  // ...args: any because console.info(...) receives ...args: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info: (...args: any) => {
    if (TrackJS.isInstalled()) {
      TrackJS.console.info(...args);
      // @ts-expect-error TS(2774): This condition will always return true since this ... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    } else if (window.console && window.console.info) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },
  // ...args: any because console.error(...) receives ...args: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: (...args: any) => {
    if (TrackJS.isInstalled()) {
      TrackJS.console.error(...args);
      // @ts-expect-error TS(2774): This condition will always return true since this ... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    } else if (window.console && window.console.error) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  },
};
